import { render, staticRenderFns } from "./CnyTypeSelect.vue?vue&type=template&id=5a222f6a&"
import script from "./CnyTypeSelect.vue?vue&type=script&lang=js&"
export * from "./CnyTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports